export const documents = new Map(
  [
    ['General', {icon: 'live_help', path: require('./general.md')}],
    ['Rules', {icon: 'assignment', path: require('./rules.md')}],
    ['Joining', {icon: 'merge_type', path: require('./joiningfiles.md')}],
    ['Paragon files', {icon: 'account_balance', path: require('./transactionfiles.md')}],
    ['Mapping files', {icon: 'map', path: require('./mapping.md')}],
    ['Attribute files', {icon: 'description', path: require('./attribute.md')}],
    ['Template files', {icon: 'file_copy', path: require('./templatefiles.md')}],
    ['Custom columns', {icon: 'edit', path: require('./customcolumns.md')}],
  ]
);
